import { useRequestURL, useRoute, useRuntimeConfig } from '#imports'
import { onMounted, ref, watchEffect } from 'vue'

import { useAuthStore } from '@backmarket/nuxt-layer-oauth/useAuthStore'
import { useI18nLocale } from '@backmarket/nuxt-module-i18n/useI18nLocale'
import { useLogger } from '@backmarket/nuxt-module-logger/useLogger'
import { useMarketplace } from '@backmarket/nuxt-module-marketplace/useMarketplace'

import { buildEducatorVerificationUrl } from './EducatorDiscountCTA.utils'

export function useEducatorVerificationUrl() {
  const url = ref<ReturnType<typeof buildEducatorVerificationUrl>>()
  const error = ref()

  const marketplace = useMarketplace()
  const authStore = useAuthStore()
  const locale = useI18nLocale()

  const { SHEER_ID_EDUCATOR_DISCOUNT_URL } = useRuntimeConfig().public

  const route = useRoute()

  const logger = useLogger()

  const requestURL = useRequestURL()

  onMounted(() => {
    watchEffect(() => {
      try {
        url.value = buildEducatorVerificationUrl({
          authenticated: authStore.authenticated,
          market: marketplace.market,
          bmUserId: authStore.bmUserId,
          currentRoute: route,
          sheerIdUrl: SHEER_ID_EDUCATOR_DISCOUNT_URL,
          originUrl: requestURL.origin,
          locale,
        })
      } catch (err) {
        logger.error(
          '[CONTENT] error when building educator verification url',
          {
            error: err as Error,
            owners: ['bot-squad-lifecycle-front'],
          },
        )
        error.value = err
      }
    })
  })

  return { url, error }
}
